var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "fill-height d-flex align-center justify-center"
  }, [_c('v-row', {
    staticClass: "login-container",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7"
    }
  }, [_c('v-card', {
    staticClass: "login-card",
    attrs: {
      "elevation": "8"
    }
  }, [_c('v-card-title', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "login-logo mb-5",
    attrs: {
      "src": "/img/siglasigfoco.svg",
      "alt": "Brasão do estado de Pernambuco"
    }
  })]), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###.###.###-##',
      expression: "'###.###.###-##'"
    }],
    staticClass: "mb-4",
    attrs: {
      "solo": "",
      "hide-details": "auto",
      "placeholder": "CPF",
      "rules": [function (v) {
        return _vm.$required(v, 'CPF é obrigatório');
      }],
      "prepend-inner-icon": "mdi-account"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.enter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.user.username,
      callback: function ($$v) {
        _vm.$set(_vm.user, "username", $$v);
      },
      expression: "user.username"
    }
  }), _c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "type": "password",
      "solo": "",
      "maxlength": "256",
      "placeholder": "Senha",
      "hide-details": "auto",
      "rules": [function (v) {
        return _vm.$required(v, 'Senha é obrigatória');
      }, function (v) {
        return _vm.$min(v, 8, 'A senha deve conter pelo menos 8 caracteres.');
      }, function (v) {
        return _vm.$max(v, 256, 'A senha deve conter no máximo 256 caracteres.');
      }],
      "prepend-inner-icon": "mdi-lock"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.enter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.user.password,
      callback: function ($$v) {
        _vm.$set(_vm.user, "password", $$v);
      },
      expression: "user.password"
    }
  }), _vm.$recaptchaDev ? _c('v-row', [_c('v-col', [_c('small', [_c('sigfoco-recaptcha', {
    on: {
      "recaptchaVerified": function ($event) {
        _vm.verified = $event;
      }
    }
  })], 1)])], 1) : _vm._e(), _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "block": "",
      "color": "success",
      "loading": _vm.loading
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.enter.apply(null, arguments);
      }
    }
  }, [_vm._v(" Entrar ")]), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0 mt-3 text-center"
  }, [_c('small', [_c('a', {
    on: {
      "click": function ($event) {
        return _vm.toggleModalRedefinirSenha(true);
      }
    }
  }, [_vm._v(" Esqueci minha senha ou não tenho senha cadastrada ")])])])], 1)], 1)], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "50%"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("Selecione o tipo de usuário:")])]), _c('div', {
    staticClass: "container dialog mt-7"
  }, [_c('v-row', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("Para redefinir sua senha, selecione a opção correspondente ao seu tipo de acesso:")]), _c('li', [_vm._v("Servidor do SAD-RH: Caso você acesse o sistema com as credenciais do SAD-RH.")]), _c('li', [_vm._v("Servidor Cadastrado: Caso você tenha definido sua senha após o cadastro por e-mail.")])])], 1), _c('div', {
    staticClass: "text-center mt-5"
  }, [_c('v-btn', {
    staticClass: "ml-2 text-body-2 font-weight-medium",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.redirectTo('SADRH');
      }
    }
  }, [_vm._v(" Servidor do SAD-RH ")]), _c('v-btn', {
    staticClass: "ml-2 text-body-2 font-weight-medium",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.redirectTo('Cadastrado');
      }
    }
  }, [_vm._v(" Servidor Cadastrado ")]), _c('v-btn', {
    staticClass: "ml-2 text-body-2 font-weight-medium",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.toggleModalRedefinirSenha(false);
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }